import fp from 'lodash/fp';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { ButtonBase } from '@deerplusofficial/pos-components';
import { color } from '@deerplusofficial/pos-helper';

const Container = styled.td`
  padding: 2px 0;
  font-size: 13px;
  color: ${color.text.title};
`;

const Text = styled(ButtonBase)`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 26px;
  height: 26px;
  border-radius: 5px;
  ${props =>
    props.active &&
    css`
      background-color: ${color.accent};
      color: #ffffff;
    `};
  ${props =>
    (props.dimmed || props.disabled) &&
    css`
      color: ${color.text.disabled};
    `};
`;

class Date extends PureComponent {
  static propTypes = {
    isOnPrevMonth: PropTypes.bool,
    isOnNextMonth: PropTypes.bool,
    active: PropTypes.bool,
    disabled: PropTypes.bool,
    children: PropTypes.number,
    onMomentChange: PropTypes.func,
  };

  static defaultProps = {
    isOnPrevMonth: false,
    isOnNextMonth: false,
    active: false,
    disabled: false,
    children: 1,
    onMomentChange: fp.identity,
  };

  onDateChange = e => {
    const {
      isOnPrevMonth,
      isOnNextMonth,
      onMomentChange,
      moment,
      children: date,
    } = this.props;

    e.preventDefault();

    if (isOnPrevMonth) moment.subtract(1, 'month');
    if (isOnNextMonth) moment.add(1, 'month');

    moment.date(date);

    onMomentChange(moment);
  };

  render() {
    const {
      active,
      isOnNextMonth,
      isOnPrevMonth,
      disabled,
      children,
    } = this.props;

    return (
      <Container>
        <Text
          active={active}
          dimmed={isOnPrevMonth || isOnNextMonth}
          disabled={disabled}
          onClick={this.onDateChange}
        >
          {children}
        </Text>
      </Container>
    );
  }
}

export default Date;



// WEBPACK FOOTER //
// ./src/components/Calendar/Date.js